import { render, staticRenderFns } from "./firstEdit.vue?vue&type=template&id=6cbd292e&scoped=true&"
import script from "./firstEdit.vue?vue&type=script&lang=js&"
export * from "./firstEdit.vue?vue&type=script&lang=js&"
import style0 from "./firstEdit.vue?vue&type=style&index=0&id=6cbd292e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbd292e",
  null
  
)

export default component.exports